import * as i18next from 'i18next'
import { createRoot } from 'react-dom/client'
import ReactDOM from 'react-dom'
import { root } from './EntryPoint/Frontend/root/root.widget'
import { dataLayerServices } from './EntryPoint/Frontend/seo/datalayer'
// STYLING IMPORTS
import './Shared/Frontend/utils/svgSymbols'
import './styling/custom-theme/stylesheets/spa.scss' // PROJECT
import { State } from './EntryPoint/Frontend/root/root.state'

export const main = async (cms_type: string, useSSR: boolean) => {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  const res = await fetch('/translations.json', { method: 'get', credentials: 'include', headers: headers })
  let resources = await res.json()
  let defaultLanguage = 'nl'
  i18next.init({
    lng: 'nl',
    fallbackLng: defaultLanguage,
    resources: resources
  })

  dataLayerServices.sendPendingGtmEvents()

  let state: State | undefined = undefined

  const container = document.querySelector('#root')
  if (!container) {
    console.error('Root container not found')
    return
  }
  const reactRoot = createRoot(container)

  reactRoot.render(root().run(s => s))

  queueMicrotask(() => {
    removeLoader()

    const rootElement = document.getElementById("root")
    const ssrRoot = document.getElementById("rootSSR")

    if (!useSSR) {
      ssrRoot?.parentNode?.removeChild(ssrRoot)
      return
    }

    setTimeout(() => {
      if (rootElement) {
        rootElement.style.display = ""
      }
      if (ssrRoot) {
        ssrRoot.style.display = "none"
        setTimeout(() => ssrRoot.parentNode?.removeChild(ssrRoot), 1000)
      }
    }, 1000)
  })
}

function removeLoader() {
  const loader = document.querySelector('#js--loader')
  if (loader == null) return
  loader.remove()
}

if (window.run_main) main(window.cms_type, window.useSSR)
